import Input from "components/common/input";
import { ErrorMessage, Formik } from "formik";
import AsyncSelect from "components/common/select/AsyncSelect";
import { useEffect, useState } from "react";
import { getZipCodes } from "containers/leadcaremanager/api";
import { initialMetaForTable } from "constants/common";
import { useDebouncedZipCodesDataCallback } from "utils/debouncedHelper";
import * as yup from "yup";

const validation = yup.object().shape({
  zip_code_id: yup.string().required("Required *"),
  spa_code: yup.string().required("Required *"),
});
const AddEditSpa = ({ handleSubmit, handleClose, spaToEdit = {} }) => {
  const { zip_code = "", spa_code = "" } = spaToEdit;
  const [zipCodesList, setZipCodesList] = useState([]);
  const debouncedZipCodesDataCallback = useDebouncedZipCodesDataCallback();

  const fetchZipCodes = async (stateId, countyId, cityId) => {
    const result = await getZipCodes({
      ...initialMetaForTable,
      state_id: stateId,
      county_id: countyId,
      city_id: cityId,
    });
    if (result["zip_codes"]) {
      setZipCodesList(result.zip_codes);
    }
  };
  useEffect(() => {
    fetchZipCodes();
  }, []);
  return (
    <Formik
      initialValues={{ zip_code_id: zip_code?.id, spa_code }}
      validationSchema={validation}
      onSubmit={(values) => {
        handleSubmit({ id: spaToEdit.id, ...values });
      }}
    >
      {({
        handleChange,
        values,
        handleSubmit,
        errors,
        touched,
        setFieldValue,
      }) => (
        <div className="question-modal">
          <hr className="custom-modal-line mt-0 " />
          <form className="form-main" onSubmit={handleSubmit}>
            <AsyncSelect
              name="zip_code_id"
              label="ZIP Code"
              options={
                zipCodesList.find((plan) => plan.id === zip_code?.id) ||
                typeof zip_code === "undefined"
                  ? zipCodesList?.map((el) => ({
                      value: el.id,
                      label: el.code,
                    }))
                  : [
                      ...zipCodesList?.map((el) => ({
                        value: el.id,
                        label: el.code,
                      })),
                      {
                        value: zip_code?.id,
                        label: zip_code?.code,
                      },
                    ]
              }
              loadOptions={(inputValue) =>
                new Promise((resolve) => {
                  debouncedZipCodesDataCallback(
                    inputValue,
                    values.state_id?.value,
                    values.county_id?.value,
                    values.city_id?.value,
                    resolve
                  );
                })
              }
              selectedValue={values.zip_code_id}
              handleChange={(obj) => setFieldValue("zip_code_id", obj?.value)}
              className="mb-1"
              error={
                <ErrorMessage
                  className="error-message"
                  component="p"
                  name="zip_code_id"
                />
              }
            />
            <Input
              handleChange={handleChange}
              placeholder="SPA Number"
              label="SPA Number"
              value={values.spa_code}
              name="spa_code"
              className="mb-1"
              error={
                <ErrorMessage
                  className="error-message"
                  component="p"
                  name="spa_code"
                />
              }
            />
            <div className="action gap-2">
              <button
                className="secondary-btn w-50"
                type="button"
                onClick={handleClose}
              >
                Cancel
              </button>
              <input
                className="primary-btn w-50"
                type="submit"
                name="submit"
                value={`${spaToEdit?.id ? "Edit" : "Add"} SPA Number`}
              />
            </div>
          </form>
        </div>
      )}
    </Formik>
  );
};

export default AddEditSpa;
